var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1.6665 10.4167C1.6665 8.46369 3.15943 6.85941 5.06629 6.68281C5.45635 4.31011 7.51671 2.5 9.99984 2.5C12.483 2.5 14.5433 4.31011 14.9334 6.68281C16.8402 6.85941 18.3332 8.46369 18.3332 10.4167C18.3332 11.7168 17.6715 12.8625 16.6665 13.5352H13.3332V13.3333L9.99984 10.2019L6.6665 13.3333V13.5352H3.33317C2.32818 12.8625 1.6665 11.7168 1.6665 10.4167Z",
    fill: "#0098A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 13.5352C2.32818 12.8625 1.6665 11.7168 1.6665 10.4167C1.6665 8.46369 3.15943 6.85941 5.06629 6.68281C5.45635 4.31011 7.51671 2.5 9.99984 2.5C12.483 2.5 14.5433 4.31011 14.9334 6.68281C16.8402 6.85941 18.3332 8.46369 18.3332 10.4167C18.3332 11.7168 17.6715 12.8625 16.6665 13.5352M6.6665 13.3333L9.99984 10M9.99984 10L13.3332 13.3333M9.99984 10V17.5",
    stroke: "#0098A5",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUpload);
export default __webpack_public_path__ + "b0d43ad02b945989dc8caf6c67a08fbe.svg";
export { ForwardRef as ReactComponent };